import {chevronUpCircleSvg as Icon__small__chevronUpCircleSvg} from '../Icon__small/Icon__small--chevronUpCircle.js';

export var chevronUpCircle = {
  name: 'chevronUpCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chevronUpCircleSvg,
};
